import { defineMessages } from 'react-intl';

export default defineMessages({
    makeChanges: {
        id: 'ml.endorsement.common.pages.AgentSignatureOptions.Make Changes',
        defaultMessage: 'Make Changes'
    },
    updatingForms: {
        id: 'ml.gateway.endorsement.common.AgentSignatureOptions.Updating forms',
        defaultMessage: 'Updating forms...'
    },
    verbalAuthorization: {
        id: 'ml.gateway.endorsement.common.AgentSignatureOptions.Verbal Authorization',
        defaultMessage: 'Verbal Authorization'
    },
    requiredSignatures: {
        id: 'ml.gateway.endorsement.common.aAgentSignatureOptions.Required Signatures',
        defaultMessage: 'Required Signatures'
    },
    availableDocuments: {
        id: 'ml.gateway.endorsement.common.aAgentSignatureOptions.Available Documents',
        defaultMessage: 'Available Documents'
    },
    yourDocuments: {
        id: 'ml.gateway.endorsement.common.AgentSignatureOptions.your policy change documents',
        defaultMessage: 'your policy change documents'
    },
    requiredForms: {
        id: 'ml.gateway.endorsement.common.AgentSignatureOptions.required forms',
        defaultMessage: 'required forms'
    },
    confirmYourPolicy: {
        id: 'ml.gateway.endorsement.common.AgentSignatureOptions.confirm your policy',
        defaultMessage: 'confirm your policy'
    },
    bundleCart: {
        id: 'ml.gateway.endorsement.common.AgentSignatureOptions.bundle cart',
        defaultMessage: 'bundle cart'
    },
    verbalAuthorizationNextDescription: {
        id: 'ml.gateway.endorsement.common.AgentSignatureOptions.verbalAuthorizationNextDescription',
        defaultMessage: 'We\'ll review additional {requiredForms} next'
    },
    requiredSignatureNextDescription: {
        id: 'ml.gateway.endorsement.common.AgentSignatureOptions.requiredSignatureNextDescription',
        defaultMessage: 'We\'ll review {yourDocuments} next'
    },
    availableDocumentsNextDescription: {
        id: 'ml.gateway.endorsement.common.AgentSignatureOptions.availableDocumentsNextDescription',
        defaultMessage: 'We\'ll {confirmYourPolicy} next'
    },
    issuePolicy: {
        id: 'ml.gateway.endorsement.common.AgentSignatureOptions.Issue Policy',
        defaultMessage: 'Issue Policy'
    },
    applySignature: {
        id: 'ml.gateway.endorsement.common.AgentSignatureOptions.Apply signature',
        defaultMessage: 'Apply signature type to all items?'
    },
    applySignatureToAll: {
        id: 'ml.gateway.endorsement.common.AgentSignatureOptions.applySignatureToAll',
        defaultMessage: 'Do you want to apply this signature type to all items in the list?'
    },
    invalidEmail:{
        id:'ml.gateway.endorsement.common.AgentSignatureOptions.invalidEmail',
        defaultMessage:"Email validation services are delayed, please verify the email entered is correct, and then proceed"
    },
    disclaimer: {
        id: 'ml.gateway.endorsement.common.AgentSignatureOptions.Disclaimer',
        defaultMessage: 'Disclaimer'
    },
    esignWarningMsg:{
         id: 'ml.gateway.endorsement.common.AgentSignatureOptions.esignWarningMsg',
        defaultMessage: 'To enable eSignature delivery, please update the customer’s preference on the Customer Preference page.'
    }
})